import React, { useState, useEffect } from "react";
import "./singleStudentFeeStyle.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  feeData,
  getParticularProgramFeeTypes,
  getSingleStudentFeeList,
  clearState,
  deleteParticularFeeDue,
  getParticularStudentTimeLine,
  getParticularStudentNotesFollowUp,
  getStudentProfileDetails,
} from "../../../reducers/feeSlice";
import SideMenu from "../../../components/Layout/menu/SideMenu";
import moment from "moment";
import PageLoader from "../../../components/UI/loader/PageLoader";
import ActionPopup from "../../../components/Popups/ActionPopup/ActionPopup";
import FeeReciept from "../../../components/Recipt/FeeReciept";
import UpdateFeePopup from "../../../components/Popups/UpdateFeePopup/UpdateFeePopup";
import EditFeeDuePopup from "../../../components/Popups/EditFeeDuePopup/EditFeeDuePopup";
import StudentStatusPopup from "../../../components/Popups/StudentStatusPopup/StudentStatusPopup";
import AddANotePopup from "../../../components/Popups/addANote/AddANotePopup";
import TaxInvoice from "../../../components/Recipt/TaxInvoice";
import Button from "../../../components/Button/Button";

const SingleStudentFee = () => {
  // const [renderComponent, onClickTabChange] = useState(0);
  const [isUpdateFeePopUpOpen, setUpdateFeePopUp] = useState(false);
  const [renderComponent, setRenderComponent] = useState(0);
  const [tabActive, setTabActive] = useState(1);

  const [activeTimeLineOrNotes, setActiveTimeLineOrNotes] = useState(4);
  const [menuId, setMenuId] = useState(null);
  const [dueDate, setDueDate] = useState("");
  const [noteType, setNoteType] = useState("normalNote"); //followUpNote
  const [addNotePopup, setAddNotePopup] = useState(false);

  /**Student Status Popup State */
  const [studentStatusPopup, setStudentStatusPopup] = useState(false);
  const [statusType, setStatusType] = useState("");

  const [studentDetails, setStudentDetails] = useState({});

  const [feeId, setFeeId] = useState("");

  /**END */

  const {
    isFetching,
    isError,
    isSuccess,
    programFeeTypeList,
    singleStudentFeeListData,
    editFeeDueSuccess,
    deleteFeeDueSuccess,
    createFeeDueSuccess,
    updateStatusSuccess,
    updateSubventionSuccess,
    transactionTypeSuccess,
    studentTimelineData,
    studentFollowupNotes,
    isTimeLineNotePublished,
    applicantProfileDetail,
    studentProfileData,
    receiptUpdatedSuccess,
  } = useSelector(feeData);
  console.log("printing profile data", studentProfileData);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [totalAmounts, setTotalAmounts] = useState({
    total: 0,
    paid: 0,
    pending: 0,
  });

  const [totalAmountRecord, setTotalAmountRecord] = useState({
    total: 0,
    paid: 0,
    pending: 0,
  });

  const [studentProfileRecord, setStudentProfileRecord] = useState({});

  const [viewOnlyAccess, setViewOnlyAccess] = useState(false);
  const [singleStudentData, setSingleStudentData] = useState(null);
  const [feeType, setFeeType] = useState([]);

  const [feeDueId, setFeeDueId] = useState(null);
  const [updateType, setUpdateType] = useState("");
  const [loanDetails, setLoanDetails] = useState(null);

  const [feeDuePopup, setFeeDuePopup] = useState(false);
  const [feeAmount, setFeeAmount] = useState("");
  const [dueType, setDueType] = useState("");

  //action states
  const [actionMessage, setActionMessage] = useState("");
  const [actionHeading, setActionHeading] = useState("");
  const [showAction, setShowAction] = useState(false);
  const [actionType, setActionType] = useState("");
  const [actionName, setActionName] = useState("");

  const studentId = searchParams.get("studentId");
  // const programMasterId = searchParams.get("programMasterId");
  const programBatchId = searchParams.get("programBatchId");
  const isStudent = searchParams.get("isStudent");

  const [showReceipt, setShowReceipt] = useState(false);
  const [receiptData, setReceiptData] = useState({});

  const [showTaxInvoice, setShowTaxInvoice] = useState(false);
  const [taxInvoiceData, setTaxInvoiceData] = useState({});

  const [studentFeeDueData, setStudentFeeDuesData] = useState(null);
  const [timeLineArray, setTimeLineArray] = useState([]);
  const [followUpArray, setFollowUpsArray] = useState([]);

  const onDownloadReceipt = (due, ft) => {
    setShowReceipt(true);
    setReceiptData({
      name: singleStudentData.firstName + " " + singleStudentData.lastName,
      feeName: due.Fee.FeeMaster.feeName,
      feeAmount: ft.amount,
      receiptNumber: ft.receiptNumber,
      paidOn: ft.paidOn,
      scholarshipAmount: due.Fee.scholarshipAmount,
      feeTaxes: due.Fee.FeeTaxes,
    });
  };

  const onDownloadTaxInvoice = (due, ft) => {
    setShowTaxInvoice(true);
    setTaxInvoiceData({
      name: singleStudentData.firstName + " " + singleStudentData.lastName,
      feeName: due.Fee.FeeMaster.feeName,
      feeAmount: ft.amount,
      receiptNumber: ft.receiptNumber,
      paidOn: ft.paidOn,
      scholarshipAmount: due.Fee.scholarshipAmount,
      feeTaxes: due.Fee.FeeTaxes,
      hsnCode: studentFeeDueData?.Program?.HsnCode,
      address: studentFeeDueData?.address,
      supplyPlace: studentFeeDueData?.supplyPlace,
      studentGSTNo: studentFeeDueData?.studentGSTNo,
      programName: studentFeeDueData?.Program?.programName,
      invoiceGeneratedOn: ft?.invoiceGeneratedOn,
    });
  };

  useEffect(() => {
    let object = {
      programBatchId: programBatchId,
    };
    dispatch(getParticularProgramFeeTypes(object));
    dispatch(getStudentProfileDetails(studentId));
  }, []);
  console.log("singleStudentData", singleStudentData);

  useEffect(() => {
    if (isError) {
      localStorage.clear();
      navigate("/login", { replace: true });
      dispatch(clearState());
    }
  }, [isError]);

  useEffect(() => {
    if (programFeeTypeList !== null) {
      setFeeType(programFeeTypeList);
    }
    if (singleStudentFeeListData !== null) {
      setSingleStudentData(singleStudentFeeListData?.studentDetails);
      setStudentFeeDuesData(singleStudentFeeListData?.studentDetails);

      setTotalAmounts({
        total: singleStudentFeeListData?.totalFeeDuesSum ?? 0,
        paid: singleStudentFeeListData?.paidAmount ?? 0,
        pending: singleStudentFeeListData?.totalPendingAmount ?? 0,
      });
    }
  }, [programFeeTypeList, singleStudentFeeListData]);

  const toggleUpdateFeePopup = () => {
    setUpdateFeePopUp((p) => !p);
    setUpdateType("");
    setLoanDetails(null);
  };

  useEffect(() => {
    let object = {
      programBatchId: programBatchId,
      studentId: studentId,
    };
    dispatch(getSingleStudentFeeList(object));
    dispatch(clearState());
  }, []);

  useEffect(() => {
    if (
      editFeeDueSuccess ||
      deleteFeeDueSuccess ||
      createFeeDueSuccess ||
      updateStatusSuccess ||
      updateSubventionSuccess ||
      transactionTypeSuccess ||
      receiptUpdatedSuccess
    ) {
      let object = {
        programBatchId: programBatchId,
        studentId: studentId,
      };
      dispatch(getSingleStudentFeeList(object));
      dispatch(clearState());

      setFeeDuePopup(false);
      setFeeAmount("");
      setDueType("");
      setFeeDueId(null);
      setDueDate("");
      setStudentStatusPopup(false);
      setStatusType("");
      setFeeDueId(null);
      setLoanDetails(null);
      setUpdateFeePopUp(false);
      setFeeId("");
    }
  }, [
    editFeeDueSuccess,
    deleteFeeDueSuccess,
    createFeeDueSuccess,
    updateStatusSuccess,
    updateSubventionSuccess,
    transactionTypeSuccess,
    receiptUpdatedSuccess,
  ]);

  useEffect(() => {
    if (isSuccess) {
      let object = {
        programBatchId: programBatchId,
        studentId: studentId,
      };
      dispatch(getSingleStudentFeeList(object));
      dispatch(clearState());
      setUpdateFeePopUp(false);
      setFeeDuePopup(false);
      setFeeAmount("");
      setDueType("");
      setFeeDueId(null);
      setDueDate("");
      setFeeId("");
    }
  }, [isSuccess]);

  const onSubmit = () => {
    if (feeDueId !== null) {
      dispatch(deleteParticularFeeDue({ feeDueId }));
      setShowAction(false);
    }
  };

  useEffect(() => {
    const isViewOnly = localStorage.getItem("viewOnlyAccess") === "true";
    if (isViewOnly) {
      setViewOnlyAccess(isViewOnly);
    }
  }, []);

  useEffect(() => {
    if (isError) {
      localStorage.clear();
      navigate("/login", { replace: true });
      dispatch(clearState());
    }
  }, [isError]);

  /**onClikc */
  const openActionMenu = (id) => {
    if (menuId === id) {
      setMenuId(null);
    } else {
      setMenuId(id);
    }
  };
  const closeActionMenu = () => {
    setMenuId(null);
  };

  const toggleFeeDuePopup = () => {
    setFeeDuePopup(true);
  };

  const onClickDeleteButton = (id) => {
    setActionHeading("Delete");
    setActionMessage("Are you sure you want to delete fee due");
    setActionName("Delete");
    setActionType("warning");
    setShowAction(true);
    setFeeDueId(id);
  };

  const toggleStudentStatusPopup = () => {
    setStudentStatusPopup(true);
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const onClickTabChange = (id) => {
    setRenderComponent(id);
    if (id === 1) {
      fetchingStudentTimeLine();
    }

    if (id === 2) {
      fetchingStudentFollowUps();
    }
  };

  // useEffect(() => {
  //   if (isStudent === "false") {
  //     setRenderComponent(3);
  //     setTabActive(3);
  //     fetchingStudentTimeLine();
  //   }
  // }, [isStudent]);

  const fetchingStudentTimeLine = () => {
    dispatch(getParticularStudentTimeLine(studentId));
  };

  const fetchingStudentFollowUps = () => {
    dispatch(getParticularStudentNotesFollowUp(studentId));
  };

  useEffect(() => {
    if (studentTimelineData?.Data) {
      setTimeLineArray(studentTimelineData?.Data);
    }
  }, [studentTimelineData]);

  useEffect(() => {
    if (studentFollowupNotes?.Data) {
      setFollowUpsArray(studentFollowupNotes?.Data);
    }
  }, [studentFollowupNotes]);

  const handleInsideTimeLineTabs = (id) => {
    setActiveTimeLineOrNotes(id);
    if (id === 4) fetchingStudentTimeLine();
    if (id === 5) fetchingStudentFollowUps();
  };

  useEffect(() => {
    if (isTimeLineNotePublished) {
      fetchingStudentFollowUps();
      dispatch(clearState());
      setUpdateFeePopUp(false);
      setFeeDuePopup(false);
      setAddNotePopup(false);
      setFeeAmount("");
      setDueType("");
      setFeeDueId(null);
      setDueDate("");
      setFeeId("");
    }
  }, [isTimeLineNotePublished]);

  useEffect(() => {
    if (studentProfileData?.IsSuccess) {
      setStudentProfileRecord(studentProfileData?.Data);
      setTotalAmountRecord({
        total: studentProfileData?.feeRecord?.totalAmount ?? 0,
        pending: studentProfileData?.feeRecord?.pendingAmount ?? 0,
        paid: studentProfileData?.feeRecord?.submittedAmount ?? 0,
      });
    }
  }, [studentProfileData]);

  const urlDocument = (applicantNumber, documentName) => {
    var str = applicantNumber;
    str = str.replaceAll("/", "");
    var finalUrl = `https://dinero-doc.s3.ap-south-1.amazonaws.com/assets/${str}/${documentName}`;
    return finalUrl;
  };

  return (
    <>
      <SideMenu />
      <AddANotePopup
        show={addNotePopup}
        handleClose={() => {
          setAddNotePopup(false);
        }}
        noteType={noteType}
        programBatchId={programBatchId}
        studentId={studentId}
      />
      <UpdateFeePopup
        show={isUpdateFeePopUpOpen}
        handleClose={toggleUpdateFeePopup}
        studentId={studentId}
        feeDueId={feeDueId}
        programBatchId={programBatchId}
        updateType={updateType}
        loanDetails={loanDetails}
      />

      {isFetching && <PageLoader />}

      <ActionPopup
        show={showAction}
        heading={actionHeading}
        handleClose={() => {
          setShowAction(false);
          setFeeDueId(null);
        }}
        message={actionMessage}
        action={actionName}
        actionType={actionType}
        onSubmit={onSubmit}
      />

      <FeeReciept
        showReceipt={showReceipt}
        setShowReceipt={(val) => setShowReceipt(val)}
        receiptData={receiptData}
      />

      <TaxInvoice
        showTaxInvoice={showTaxInvoice}
        setShowTaxInvoice={(val) => setShowTaxInvoice(val)}
        taxInvoiceData={taxInvoiceData}
      />

      <EditFeeDuePopup
        closePopup={() => {
          setFeeDuePopup(false);
          setFeeAmount("");
          setDueType("");
          setDueDate("");
          setFeeId("");
        }}
        show={feeDuePopup}
        feeAmount={feeAmount}
        dueType={dueType}
        programBatchId={programBatchId}
        feeDueId={feeDueId}
        studentId={studentId}
        dueDate={dueDate}
        feeType={feeType}
        feeId={feeId}
      />

      <StudentStatusPopup
        closePopup={() => {
          setStudentStatusPopup(false);
          setStatusType("");
          setFeeDueId(null);
        }}
        show={studentStatusPopup}
        statusType={statusType}
        studentId={studentId}
        feeDueId={feeDueId}
        studentDetails={studentDetails}
      />

      <div className="main-body particularStudent">
        <div className="page-header">
          <button className="component-back">
            <img src="../assets/icons/back-btn.svg" />
            Back
          </button>
        </div>
        <div className="studentProfilerTabContainer">
          <div className="studentProfileBoxOuter newDesignClrBox">
            <div className="studentProfileBoxContainer">
              <div className="studentProfileBox">
                <div className="studentNameBox">
                  <span className="letter">
                    {studentProfileRecord?.firstName &&
                      studentProfileRecord?.firstName.charAt(0)}
                  </span>
                  <p className="studnetName">
                    {studentProfileRecord?.firstName ?? ""}{" "}
                    {studentProfileRecord?.lastName ?? ""}
                  </p>
                </div>
                <div className="studentProfileDetails">
                  <p className="studentProfileDetail">
                    <span>Email:</span>{" "}
                    {studentProfileRecord?.officialEmail ?? "N/A"}
                  </p>
                  <p className="studentProfileDetail">
                    <span>DOB:</span>{" "}
                    {moment(
                      studentProfileRecord?.applicantdetail?.Date_Of_Birth
                    ).format("ll") ?? "N/A"}
                  </p>
                  <p className="studentProfileDetail">
                    <span>Mobile no. :</span>{" "}
                    {studentProfileRecord?.mobileNumber ?? "N/A"}
                  </p>
                  <p className="studentProfileDetail">
                    <span>State:</span>{" "}
                    {studentProfileRecord?.applicantdetail?.State_Current ??
                      "N/A"}
                  </p>
                  <p className="studentProfileDetail">
                    <span>Alternate Mobile no. :</span> N/A
                  </p>
                  <p className="studentProfileDetail">
                    <span>City:</span>{" "}
                    {studentProfileRecord?.applicantdetail?.City_Current ??
                      "N/A"}
                  </p>
                  <p className="studentProfileDetail">
                    <span>Parent Name:</span>{" "}
                    {studentProfileRecord?.applicantdetail?.ParentName ?? "N/A"}
                  </p>
                  <br />

                  <p className="studentProfileDetail">
                    <span>LinkedIn:</span>{" "}
                    <a
                      target="_blank"
                      href={
                        studentProfileRecord?.applicantdetail
                          ?.LinkedInProfileURL
                      }
                    >
                      {" "}
                      {studentProfileRecord?.applicantdetail
                        ?.LinkedInProfileURL ?? ""}
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="studentProfileBoxContainer">
              <div className="studentProfileBox">
                <div className="studentProfileBoxInner">
                  <p className="heading">
                    {studentProfileRecord?.applicationId}
                  </p>
                  <p className="text">Applicant number</p>
                </div>
              </div>
              <div className="studentProfileBox">
                <div className="studentProfileBoxInnerContainer">
                  <div className="studentProfileBoxInner">
                    <p className="heading">
                      {studentProfileRecord?.ProgramDetail?.Program
                        ?.programName ?? "N/A"}
                    </p>
                    <p className="text">Program Name</p>
                  </div>
                  <div className="studentProfileBoxInner">
                    <p className="heading">
                      {studentProfileRecord?.ProgramDetail?.durationInMonths ??
                        "N/A"}{" "}
                      months
                    </p>
                    <p className="text">Duration</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="studentProfileBoxContainer">
              <div className="feeDetailsBoxContainer">
                <div className="feeDetailsBox danger">
                  <p className="heading">₹ {totalAmountRecord?.pending}</p>
                  <p className="text">Pending</p>
                </div>
                <div className="feeDetailsBox success">
                  <p className="heading">₹ {totalAmountRecord?.paid}</p>
                  <p className="text">Received</p>
                </div>
                <div className="feeDetailsBox primary">
                  <p className="heading">₹ {totalAmountRecord?.total}</p>
                  <p className="text">Total Dues</p>
                </div>
              </div>
              <div className="studentProfileBox orange">
                <div className="studentProfileBoxInnerContainer">
                  <div className="studentProfileBoxInner">
                    <p className="heading">
                      {moment(studentProfileRecord?.createdAt).format("lll")}
                    </p>
                    <p className="text">Apply Start Date</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="studentProfileDataTabsContainer newDesignClr">
            <div className="studentProfileDataTabsOuter">
              <div className="studentProfileDataTabs">
                <div
                  className={`studentProfileDataTab ${
                    renderComponent === 0 ? "active" : ""
                  }`}
                  onClick={() => onClickTabChange(0)}
                >
                  <div>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.09961 7.0001C9.09961 6.77918 9.2787 6.6001 9.49961 6.6001H11.9996C12.2205 6.6001 12.3996 6.77918 12.3996 7.0001C12.3996 7.22101 12.2205 7.4001 11.9996 7.4001H9.49961C9.2787 7.4001 9.09961 7.22101 9.09961 7.0001Z"
                        fill="#101010"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.09961 9.0001C9.09961 8.77918 9.2787 8.6001 9.49961 8.6001H11.9996C12.2205 8.6001 12.3996 8.77918 12.3996 9.0001C12.3996 9.22101 12.2205 9.4001 11.9996 9.4001H9.49961C9.2787 9.4001 9.09961 9.22101 9.09961 9.0001Z"
                        fill="#101010"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.75547 6.4001C5.14796 6.4001 4.65547 6.89258 4.65547 7.5001C4.65547 8.10761 5.14796 8.6001 5.75547 8.6001C6.36298 8.6001 6.85547 8.10761 6.85547 7.5001C6.85547 6.89258 6.36298 6.4001 5.75547 6.4001ZM3.85547 7.5001C3.85547 6.45076 4.70613 5.6001 5.75547 5.6001C6.80481 5.6001 7.65547 6.45076 7.65547 7.5001C7.65547 8.54944 6.80481 9.4001 5.75547 9.4001C4.70613 9.4001 3.85547 8.54944 3.85547 7.5001Z"
                        fill="#101010"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.75597 9.4001C5.4012 9.40011 5.05648 9.51799 4.77598 9.73521C4.49548 9.95243 4.2951 10.2567 4.20631 10.6002C4.15103 10.8141 3.93282 10.9426 3.71894 10.8873C3.50506 10.8321 3.37649 10.6139 3.43177 10.4C3.56493 9.88481 3.86546 9.42849 4.28616 9.1027C4.70685 8.77691 5.22385 8.60012 5.75594 8.6001C6.28803 8.60008 6.80505 8.77684 7.22576 9.1026C7.64648 9.42835 7.94704 9.88466 8.08024 10.3998C8.13554 10.6137 8.00698 10.8319 7.7931 10.8872C7.57922 10.9425 7.36101 10.8139 7.30571 10.6001C7.2169 10.2566 7.0165 9.95234 6.73598 9.73514C6.45547 9.51794 6.11074 9.40009 5.75597 9.4001Z"
                        fill="#101010"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.49961 3.4001C2.44438 3.4001 2.39961 3.44487 2.39961 3.5001V12.5001C2.39961 12.5553 2.44438 12.6001 2.49961 12.6001H13.4996C13.5548 12.6001 13.5996 12.5553 13.5996 12.5001V3.5001C13.5996 3.44487 13.5548 3.4001 13.4996 3.4001H2.49961ZM1.59961 3.5001C1.59961 3.00304 2.00255 2.6001 2.49961 2.6001H13.4996C13.9967 2.6001 14.3996 3.00304 14.3996 3.5001V12.5001C14.3996 12.9972 13.9967 13.4001 13.4996 13.4001H2.49961C2.00255 13.4001 1.59961 12.9972 1.59961 12.5001V3.5001Z"
                        fill="#101010"
                      />
                    </svg>
                    <p>Profile Details</p>
                  </div>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.43306 16.8136C6.18898 16.5651 6.18898 16.1622 6.43306 15.9137L12.2411 10L6.43306 4.08634C6.18898 3.83782 6.18898 3.4349 6.43306 3.18639C6.67714 2.93787 7.07286 2.93787 7.31694 3.18639L13.5669 9.55002C13.811 9.79854 13.811 10.2015 13.5669 10.45L7.31694 16.8136C7.07286 17.0621 6.67714 17.0621 6.43306 16.8136Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div
                  className={`studentProfileDataTab ${
                    renderComponent === 1 ? "active" : ""
                  }`}
                  onClick={() => onClickTabChange(1)}
                >
                  <div>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.33333 0.833496C5.60948 0.833496 5.83333 1.05735 5.83333 1.3335V2.16683H10.1667V1.3335C10.1667 1.05735 10.3905 0.833496 10.6667 0.833496C10.9428 0.833496 11.1667 1.05735 11.1667 1.3335V2.16714C11.553 2.16824 11.8789 2.17323 12.1543 2.19574C12.5187 2.22551 12.8388 2.28842 13.135 2.43931C13.6054 2.679 13.9878 3.06145 14.2275 3.53185C14.3784 3.828 14.4413 4.14809 14.4711 4.51252C14.5 4.86645 14.5 5.30353 14.5 5.84541V11.4882C14.5 12.0301 14.5 12.4672 14.4711 12.8211C14.4413 13.1856 14.3784 13.5057 14.2275 13.8018C13.9878 14.2722 13.6054 14.6547 13.135 14.8943C12.8388 15.0452 12.5187 15.1081 12.1543 15.1379C11.8004 15.1668 11.3633 15.1668 10.8214 15.1668H5.17858C4.6367 15.1668 4.19963 15.1668 3.84569 15.1379C3.48126 15.1081 3.16117 15.0452 2.86502 14.8943C2.39462 14.6547 2.01217 14.2722 1.77248 13.8018C1.62159 13.5057 1.55868 13.1856 1.52891 12.8211C1.49999 12.4672 1.5 12.0301 1.5 11.4882V5.84543C1.5 5.30353 1.49999 4.86646 1.52891 4.51252C1.55868 4.14809 1.62159 3.828 1.77248 3.53185C2.01217 3.06145 2.39462 2.679 2.86502 2.43931C3.16117 2.28842 3.48126 2.22551 3.84569 2.19574C4.12114 2.17323 4.44695 2.16824 4.83333 2.16714V1.3335C4.83333 1.05735 5.05719 0.833496 5.33333 0.833496ZM4.83333 3.16719C4.45369 3.16833 4.16443 3.17303 3.92712 3.19242C3.62454 3.21714 3.45069 3.26323 3.31901 3.33032C3.03677 3.47413 2.8073 3.7036 2.66349 3.98584C2.5964 4.11752 2.55031 4.29137 2.52559 4.59395C2.50039 4.90237 2.5 5.29853 2.5 5.86683V6.16683H13.5V5.86683C13.5 5.29853 13.4996 4.90237 13.4744 4.59395C13.4497 4.29137 13.4036 4.11752 13.3365 3.98584C13.1927 3.7036 12.9632 3.47413 12.681 3.33032C12.5493 3.26323 12.3755 3.21714 12.0729 3.19242C11.8356 3.17303 11.5463 3.16833 11.1667 3.16719V4.00016C11.1667 4.27631 10.9428 4.50016 10.6667 4.50016C10.3905 4.50016 10.1667 4.27631 10.1667 4.00016V3.16683H5.83333V4.00016C5.83333 4.27631 5.60948 4.50016 5.33333 4.50016C5.05719 4.50016 4.83333 4.27631 4.83333 4.00016V3.16719ZM13.5 7.16683H2.5V11.4668C2.5 12.0351 2.50039 12.4313 2.52559 12.7397C2.55031 13.0423 2.5964 13.2161 2.66349 13.3478C2.8073 13.6301 3.03677 13.8595 3.31901 14.0033C3.45069 14.0704 3.62454 14.1165 3.92712 14.1412C4.23554 14.1664 4.6317 14.1668 5.2 14.1668H10.8C11.3683 14.1668 11.7645 14.1664 12.0729 14.1412C12.3755 14.1165 12.5493 14.0704 12.681 14.0033C12.9632 13.8595 13.1927 13.6301 13.3365 13.3478C13.4036 13.2161 13.4497 13.0423 13.4744 12.7397C13.4996 12.4313 13.5 12.0351 13.5 11.4668V7.16683ZM8.23593 8.22599C8.39851 8.313 8.5 8.48243 8.5 8.66683V11.5002H8.83333C9.10948 11.5002 9.33333 11.724 9.33333 12.0002C9.33333 12.2763 9.10948 12.5002 8.83333 12.5002H7.16667C6.89052 12.5002 6.66667 12.2763 6.66667 12.0002C6.66667 11.724 6.89052 11.5002 7.16667 11.5002H7.5V9.60109L7.27735 9.74952C7.04759 9.9027 6.73715 9.84061 6.58398 9.61085C6.4308 9.38108 6.49289 9.07065 6.72265 8.91747L7.72265 8.2508C7.87608 8.14852 8.07335 8.13898 8.23593 8.22599Z"
                        fill="#101010"
                      />
                    </svg>

                    <p>Timeline</p>
                  </div>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.43306 16.8136C6.18898 16.5651 6.18898 16.1622 6.43306 15.9137L12.2411 10L6.43306 4.08634C6.18898 3.83782 6.18898 3.4349 6.43306 3.18639C6.67714 2.93787 7.07286 2.93787 7.31694 3.18639L13.5669 9.55002C13.811 9.79854 13.811 10.2015 13.5669 10.45L7.31694 16.8136C7.07286 17.0621 6.67714 17.0621 6.43306 16.8136Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div
                  className={`studentProfileDataTab ${
                    renderComponent === 2 ? "active" : ""
                  }`}
                  onClick={() => onClickTabChange(2)}
                >
                  <div>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.0607 2.93934C12.4749 2.35355 11.5252 2.35355 10.9394 2.93934C10.3536 3.52513 10.3536 4.47487 10.9394 5.06066C11.5252 5.64645 12.4749 5.64645 13.0607 5.06066C13.6465 4.47487 13.6465 3.52513 13.0607 2.93934ZM10.2323 2.23223C11.2086 1.25592 12.7915 1.25592 13.7678 2.23223C14.7441 3.20854 14.7441 4.79146 13.7678 5.76777C12.7915 6.74408 11.2086 6.74408 10.2323 5.76777C9.25595 4.79146 9.25595 3.20854 10.2323 2.23223ZM5.17863 2.16667L7.33337 2.16667C7.60951 2.16667 7.83337 2.39052 7.83337 2.66667C7.83337 2.94281 7.60951 3.16667 7.33337 3.16667H5.20003C4.63173 3.16667 4.23557 3.16706 3.92715 3.19225C3.62457 3.21698 3.45072 3.26306 3.31905 3.33016C3.0368 3.47397 2.80733 3.70344 2.66352 3.98568C2.59643 4.11736 2.55034 4.2912 2.52562 4.59379C2.50042 4.90221 2.50003 5.29836 2.50003 5.86667V9.33333C2.50003 9.98551 2.50433 10.2135 2.55114 10.3882C2.68984 10.9059 3.09417 11.3102 3.6118 11.4489C3.78653 11.4957 4.01453 11.5 4.6667 11.5C4.94284 11.5 5.1667 11.7239 5.1667 12V13.557C5.1667 13.5814 5.16671 13.6045 5.16674 13.6263C5.18376 13.6127 5.20177 13.5983 5.22086 13.583L6.81116 12.3108C6.82387 12.3006 6.83642 12.2906 6.84879 12.2807C7.13748 12.0496 7.3374 11.8896 7.56422 11.7737C7.76481 11.6712 7.97833 11.5963 8.19899 11.551C8.4485 11.4998 8.70456 11.4999 9.07435 11.5C9.0902 11.5 9.10626 11.5 9.12253 11.5H10.1334C10.7017 11.5 11.0978 11.4996 11.4062 11.4744C11.7088 11.4497 11.8827 11.4036 12.0144 11.3365C12.2966 11.1927 12.5261 10.9632 12.6699 10.681C12.737 10.5493 12.7831 10.3755 12.8078 10.0729C12.833 9.76446 12.8334 9.3683 12.8334 8.8V8.66667C12.8334 8.39052 13.0572 8.16667 13.3334 8.16667C13.6095 8.16667 13.8334 8.39052 13.8334 8.66667V8.82142C13.8334 9.3633 13.8334 9.80037 13.8045 10.1543C13.7747 10.5187 13.7118 10.8388 13.5609 11.135C13.3212 11.6054 12.9387 11.9878 12.4683 12.2275C12.1722 12.3784 11.8521 12.4413 11.4877 12.4711C11.1337 12.5 10.6967 12.5 10.1548 12.5H9.12253C8.68647 12.5 8.53777 12.5024 8.40003 12.5306C8.26764 12.5578 8.13952 12.6027 8.01917 12.6642C7.89395 12.7282 7.77636 12.8192 7.43586 13.0917L5.83011 14.3763C5.70483 14.4765 5.58549 14.572 5.4823 14.6402C5.3826 14.7061 5.21402 14.8062 5.00094 14.8065C4.74715 14.8067 4.50707 14.6913 4.34875 14.493C4.21582 14.3265 4.18866 14.1323 4.17785 14.0133C4.16666 13.8901 4.16668 13.7372 4.1667 13.5768L4.1667 12.4982C3.83849 12.4935 3.58208 12.4762 3.35298 12.4148C2.49026 12.1836 1.81639 11.5098 1.58522 10.647C1.49971 10.3279 1.49984 9.95584 1.50002 9.41053C1.50002 9.38518 1.50003 9.35945 1.50003 9.33333L1.50003 5.84526C1.50003 5.30337 1.50002 4.86629 1.52894 4.51235C1.55872 4.14793 1.62162 3.82784 1.77252 3.53169C2.0122 3.06129 2.39465 2.67883 2.86506 2.43915C3.1612 2.28826 3.4813 2.22535 3.84572 2.19558C4.19966 2.16666 4.63674 2.16666 5.17863 2.16667Z"
                        fill="#101010"
                      />
                    </svg>

                    <p>Follow Up & Notes</p>
                  </div>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.43306 16.8136C6.18898 16.5651 6.18898 16.1622 6.43306 15.9137L12.2411 10L6.43306 4.08634C6.18898 3.83782 6.18898 3.4349 6.43306 3.18639C6.67714 2.93787 7.07286 2.93787 7.31694 3.18639L13.5669 9.55002C13.811 9.79854 13.811 10.2015 13.5669 10.45L7.31694 16.8136C7.07286 17.0621 6.67714 17.0621 6.43306 16.8136Z"
                      fill="white"
                    />
                  </svg>
                </div>

                {isStudent === "true" && (
                  <>
                    <div
                      className={`studentProfileDataTab ${
                        renderComponent === 3 ? "active" : ""
                      }`}
                      onClick={() => onClickTabChange(3)}
                    >
                      <div>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3.49961 2.4001C3.47309 2.4001 3.44765 2.41063 3.4289 2.42939C3.41015 2.44814 3.39961 2.47358 3.39961 2.5001V13.5001C3.39961 13.5266 3.41015 13.5521 3.4289 13.5708C3.44765 13.5896 3.47309 13.6001 3.49961 13.6001H12.5001C12.5132 13.6001 12.5262 13.5975 12.5384 13.5925C12.5505 13.5875 12.5615 13.5801 12.5708 13.5708C12.5801 13.5615 12.5875 13.5505 12.5925 13.5384C12.5975 13.5262 12.6001 13.5132 12.6001 13.5001V5.66578L9.33441 2.4001H3.49961ZM2.86321 1.8637C3.032 1.69492 3.26091 1.6001 3.49961 1.6001H9.5001C9.60618 1.6001 9.70793 1.64224 9.78294 1.71725L13.2829 5.21726C13.358 5.29227 13.4001 5.39401 13.4001 5.5001V13.5001C13.4001 13.6183 13.3768 13.7353 13.3316 13.8445C13.2864 13.9537 13.2201 14.0529 13.1365 14.1365C13.0529 14.2201 12.9537 14.2864 12.8445 14.3316C12.7353 14.3768 12.6183 14.4001 12.5001 14.4001H3.49961C3.26092 14.4001 3.032 14.3053 2.86321 14.1365C2.69443 13.9677 2.59961 13.7388 2.59961 13.5001V2.5001C2.59961 2.2614 2.69443 2.03248 2.86321 1.8637Z"
                            fill="#101010"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.50059 1.6001C9.7215 1.6001 9.90059 1.77918 9.90059 2.0001V5.1001H13.0011C13.222 5.1001 13.4011 5.27918 13.4011 5.5001C13.4011 5.72101 13.222 5.9001 13.0011 5.9001H9.50059C9.27967 5.9001 9.10059 5.72101 9.10059 5.5001V2.0001C9.10059 1.77918 9.27967 1.6001 9.50059 1.6001Z"
                            fill="#101010"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.71774 7.21725C7.87395 7.06105 8.12722 7.06105 8.28343 7.21725L10.0334 8.96725C10.1896 9.12346 10.1896 9.37673 10.0334 9.53294C9.87722 9.68915 9.62395 9.68915 9.46774 9.53294L8.00059 8.06578L6.53343 9.53294C6.37722 9.68915 6.12395 9.68915 5.96774 9.53294C5.81153 9.37673 5.81153 9.12346 5.96774 8.96725L7.71774 7.21725Z"
                            fill="#101010"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.00059 7.1001C8.2215 7.1001 8.40059 7.27918 8.40059 7.5001V11.5001C8.40059 11.721 8.2215 11.9001 8.00059 11.9001C7.77967 11.9001 7.60059 11.721 7.60059 11.5001V7.5001C7.60059 7.27918 7.77967 7.1001 8.00059 7.1001Z"
                            fill="#101010"
                          />
                        </svg>

                        <p>Fee Dues</p>
                      </div>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.43306 16.8136C6.18898 16.5651 6.18898 16.1622 6.43306 15.9137L12.2411 10L6.43306 4.08634C6.18898 3.83782 6.18898 3.4349 6.43306 3.18639C6.67714 2.93787 7.07286 2.93787 7.31694 3.18639L13.5669 9.55002C13.811 9.79854 13.811 10.2015 13.5669 10.45L7.31694 16.8136C7.07286 17.0621 6.67714 17.0621 6.43306 16.8136Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div
                      className={`studentProfileDataTab ${
                        renderComponent === 4 ? "active" : ""
                      }`}
                      onClick={() => onClickTabChange(4)}
                    >
                      <div>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M5.59961 8.00059C5.59961 7.77967 5.7787 7.60059 5.99961 7.60059H9.99961C10.2205 7.60059 10.3996 7.77967 10.3996 8.00059C10.3996 8.2215 10.2205 8.40059 9.99961 8.40059H5.99961C5.7787 8.40059 5.59961 8.2215 5.59961 8.00059Z"
                            fill="#101010"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M5.59961 10.0006C5.59961 9.77967 5.7787 9.60059 5.99961 9.60059H9.99961C10.2205 9.60059 10.3996 9.77967 10.3996 10.0006C10.3996 10.2215 10.2205 10.4006 9.99961 10.4006H5.99961C5.7787 10.4006 5.59961 10.2215 5.59961 10.0006Z"
                            fill="#101010"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3.49961 2.90059C3.47309 2.90059 3.44765 2.91112 3.4289 2.92988C3.41014 2.94863 3.39961 2.97406 3.39961 3.00059V12.5006C3.39961 12.7923 3.5155 13.0721 3.72179 13.2784C3.92808 13.4847 4.20787 13.6006 4.49961 13.6006H11.4996C11.7913 13.6006 12.0711 13.4847 12.2774 13.2784C12.4837 13.0721 12.5996 12.7923 12.5996 12.5006V3.00059C12.5996 2.97406 12.5891 2.94863 12.5703 2.92988C12.5516 2.91112 12.5261 2.90059 12.4996 2.90059H3.49961ZM2.86321 2.36419C3.032 2.19541 3.26091 2.10059 3.49961 2.10059H12.4996C12.7383 2.10059 12.9672 2.19541 13.136 2.36419C13.3048 2.53297 13.3996 2.76189 13.3996 3.00059V12.5006C13.3996 13.0045 13.1994 13.4878 12.8431 13.8441C12.4868 14.2004 12.0035 14.4006 11.4996 14.4006H4.49961C3.9957 14.4006 3.51243 14.2004 3.15611 13.8441C2.79979 13.4878 2.59961 13.0045 2.59961 12.5006V3.00059C2.59961 2.76189 2.69443 2.53297 2.86321 2.36419Z"
                            fill="#101010"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M4.99961 1.10059C5.22052 1.10059 5.39961 1.27967 5.39961 1.50059V3.50059C5.39961 3.7215 5.22052 3.90059 4.99961 3.90059C4.7787 3.90059 4.59961 3.7215 4.59961 3.50059V1.50059C4.59961 1.27967 4.7787 1.10059 4.99961 1.10059Z"
                            fill="#101010"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.99961 1.10059C8.22052 1.10059 8.39961 1.27967 8.39961 1.50059V3.50059C8.39961 3.7215 8.22052 3.90059 7.99961 3.90059C7.7787 3.90059 7.59961 3.7215 7.59961 3.50059V1.50059C7.59961 1.27967 7.7787 1.10059 7.99961 1.10059Z"
                            fill="#101010"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.9996 1.10059C11.2205 1.10059 11.3996 1.27967 11.3996 1.50059V3.50059C11.3996 3.7215 11.2205 3.90059 10.9996 3.90059C10.7787 3.90059 10.5996 3.7215 10.5996 3.50059V1.50059C10.5996 1.27967 10.7787 1.10059 10.9996 1.10059Z"
                            fill="#101010"
                          />
                        </svg>
                        <p>Transactions</p>
                      </div>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.43306 16.8136C6.18898 16.5651 6.18898 16.1622 6.43306 15.9137L12.2411 10L6.43306 4.08634C6.18898 3.83782 6.18898 3.4349 6.43306 3.18639C6.67714 2.93787 7.07286 2.93787 7.31694 3.18639L13.5669 9.55002C13.811 9.79854 13.811 10.2015 13.5669 10.45L7.31694 16.8136C7.07286 17.0621 6.67714 17.0621 6.43306 16.8136Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="studentProfileDataContainer">
              <div
                className={`profileTab ${
                  renderComponent === 0 ? "active" : ""
                }`}
              >
                <div className="profileTabHeader">
                  <p className="heading">Profile Details</p>
                </div>
                <div className="profileTabBody">
                  <div className="academicDetailsContainer">
                    <div
                      className="academicDetailsBox"
                      style={{ width: "100%" }}
                    >
                      <div className="academicDetailsBoxHeader">
                        <div className="heading">Address</div>
                      </div>
                      <div className="academicDetailsBoxBody">
                        <p className="academicDetailText w-100">
                          <span>House No./Flat No.:</span>{" "}
                          {studentProfileRecord?.applicantdetail?.HouseNo ??
                            "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>Apartment/Road/Area:</span>{" "}
                          {studentProfileRecord?.applicantdetail
                            ?.ApartmentRoadArea ?? "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>Landmark:</span>{" "}
                          {studentProfileRecord?.applicantdetail?.Landmark ??
                            "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>Pin Code :</span>{" "}
                          {studentProfileRecord?.applicantdetail?.PinCode ??
                            "N/A"}
                        </p>

                        <p className="academicDetailText">
                          <span>Shipping Address :</span>{" "}
                          {studentProfileRecord?.applicantdetail
                            ?.Address1_Current ?? "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* 
                  <div className="academicDetailsContainer">
                    <div className="academicDetailsBox">
                      <div className="academicDetailsBoxHeader">
                        <div className="heading">10 Academic Details</div>
                      </div>
                      <div className="academicDetailsBoxBody">
                        <p className="academicDetailText w-100">
                          <span>Institute Name:</span>{" "}
                          {studentProfileRecord?.applicanteducationaldetail
                            ?.School_Class10 ?? "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>Year of Passing:</span>{" "}
                          {studentProfileRecord?.applicanteducationaldetail
                            ?.Year_Of_Passing_Class10 ?? "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>Marking Scheme:</span>{" "}
                          {studentProfileRecord?.applicanteducationaldetail
                            ?.Marking_Scheme_Class10 ?? "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>
                            Obtained CGPA / Percentage{" "}
                            {
                              studentProfileRecord?.applicanteducationaldetail
                                ?.Marking_Scheme_Class10
                            }
                            :
                          </span>{" "}
                          {studentProfileRecord?.applicanteducationaldetail
                            ?.Grades_Class10 ?? "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>Board:</span>{" "}
                          {studentProfileRecord?.applicanteducationaldetail
                            ?.Board_Class10 ?? "N/A"}{" "}
                          Schools
                        </p>
                      </div>
                    </div>

                    <div className="academicDetailsBox">
                      <div className="academicDetailsBoxHeader">
                        <div className="heading">12 Academic Details</div>
                      </div>
                      <div className="academicDetailsBoxBody">
                        <p className="academicDetailText w-100">
                          <span>Institute Name:</span>{" "}
                          {studentProfileRecord?.applicanteducationaldetail
                            ?.School_Class12 ?? "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>Stream:</span>{" "}
                          {studentProfileRecord?.applicanteducationaldetail
                            ?.Stream_Class12 ?? "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>Year of Passing:</span>{" "}
                          {studentProfileRecord?.applicanteducationaldetail
                            ?.Year_Of_Passing_Class12 ?? "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>Marking Scheme:</span>{" "}
                          {studentProfileRecord?.applicanteducationaldetail
                            ?.Marking_Scheme_Class12 ?? "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>
                            Obtained{" "}
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Marking_Scheme_Class12 === "Percentage"
                              ? "Percentage"
                              : "CGPA"}
                            :
                          </span>{" "}
                          {studentProfileRecord?.applicanteducationaldetail
                            ?.Grades_Class12 ?? "N/A"}
                        </p>
                        <p className="academicDetailText">
                          <span>Board:</span>{" "}
                          {studentProfileRecord?.applicanteducationaldetail
                            ?.Board_Class12 ?? "N/A"}{" "}
                          Schools
                        </p>
                      </div>
                    </div>
                  </div> */}

                  <div className="semesterWiseData">
                    <p className="heading">10th Academic Details</p>
                    <table
                      className="semesterWiseTable"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th>Institute</th>
                          <th>Board</th>
                          <th>Year Of Passing</th>
                          <th>Marking Scheme</th>
                          <th>Obtained CGPA/Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>10th</td>
                          <td>
                            {
                              studentProfileRecord?.applicanteducationaldetail
                                ?.School_Class10
                            }
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Board_Class10 ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Year_Of_Passing_Class10 ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Marking_Scheme_Class10 ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Grades_Class10 ?? "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="semesterWiseData">
                    <p className="heading">12th Academic Details</p>
                    <table
                      className="semesterWiseTable"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th>Institute</th>
                          <th>Board</th>
                          <th>Stream</th>
                          <th>Year Of Passing</th>
                          <th>Marking Scheme</th>
                          <th>Obtained CGPA/Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>12th</td>
                          <td>
                            {
                              studentProfileRecord?.applicanteducationaldetail
                                ?.School_Class12
                            }
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Board_Class12 ?? "N/A"}
                          </td>
                          <td>
                            {
                              studentProfileRecord?.applicanteducationaldetail
                                ?.Stream_Class12
                            }
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Year_Of_Passing_Class12 ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Marking_Scheme_Class12 ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Grades_Class12 ?? "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="semesterWiseData">
                    <p className="heading">Graduation Academic Details</p>
                    <table
                      className="semesterWiseTable"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th>Institute</th>
                          <th>University</th>
                          <th>Degree</th>
                          <th>Year Of Passing</th>
                          <th>Result Status</th>
                          <th>Marking Scheme</th>
                          <th>Obtained CGPA/Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>UG</td>
                          <td>
                            {
                              studentProfileRecord?.applicanteducationaldetail
                                ?.Institute_Undergrad
                            }
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.University_Undergrad ?? "N/A"}
                          </td>
                          <td>
                            {
                              studentProfileRecord?.applicanteducationaldetail
                                ?.Degree_Undergrad
                            }
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Month_And_Year_Of_Completion_Undergrad ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Result_Status_Undergrad ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Marking_Scheme_Undergrad ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Grades_Undergrad ?? "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="semesterWiseData">
                    <p className="heading">Work Experience Details</p>
                    <table
                      className="semesterWiseTable"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th>Company</th>
                          <th>Designation</th>
                          <th>Job profile</th>
                          <th>Remuneration</th>
                          <th>Total Exp</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1.</td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Company_WorkEx1 ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Job_Title_WorkEx1 ?? "N/A"}
                          </td>
                          <td>N/A</td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Annual_Salary_With_Currency_WorkEx1 ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Duration_WorkEx1 ?? "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <td>2.</td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Company_WorkEx2 ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Job_Title_WorkEx2 ?? "N/A"}
                          </td>
                          <td>N/A</td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Annual_Salary_With_Currency_WorkEx2 ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Duration_WorkEx2 ?? "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <td>3.</td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Company_WorkEx3 ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Job_Title_WorkEx3 ?? "N/A"}
                          </td>
                          <td>N/A</td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Annual_Salary_With_Currency_WorkEx3 ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicantworkingexperience
                              ?.Duration_WorkEx3 ?? "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="semesterWiseData">
                    <p className="heading">Post Graduation, if any</p>
                    <table
                      className="semesterWiseTable"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th>Institute</th>
                          <th>University</th>
                          <th>Degree</th>
                          <th>Year Of Passing</th>
                          <th>Result Status</th>
                          <th>Marking Scheme</th>
                          <th>Obtained CGPA/Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>PG</td>
                          <td>
                            {
                              studentProfileRecord?.applicanteducationaldetail
                                ?.Institution_Name
                            }
                          </td>
                          <td>
                            {/* {studentProfileRecord?.applicanteducationaldetail
                              ?.University_Undergrad ??
                              "N/A"} */}
                          </td>
                          <td>
                            {/* {studentProfileRecord?.applicanteducationaldetail
                              ?.Degree_Undergrad} */}
                          </td>
                          <td>
                            {/* {studentProfileRecord?.applicanteducationaldetail
                              ?.Month_And_Year_Of_Completion_Undergrad ?? "N/A"} */}
                          </td>
                          <td>
                            {/* {studentProfileRecord?.applicanteducationaldetail
                              ?.Result_Status_Undergrad ?? "N/A"} */}
                          </td>
                          <td>
                            {/* {studentProfileRecord?.applicanteducationaldetail
                              ?.Marking_Scheme_Undergrad ?? "N/A"} */}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Percentage_CGPA_Obtained ?? "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="semesterWiseData">
                    <table
                      className="semesterWiseTable"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <thead className="darkHeads">
                        <tr>
                          <th>
                            Why do you wish to enroll in this programme? How
                            will it help in your professional goals?
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {studentProfileRecord?.applicantadditionaldetail
                              ?.How_is_this_MasterCamp_course_aligned_with_your_career_goals ??
                              "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* 
                  <div className="semesterWiseData">
                    <p className="heading">UnderGraduate Academic Details</p>
                    <table
                      className="semesterWiseTable"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th>University/College</th>
                          <th>Month & Year Of Commencement</th>
                          <th>Month & Year Of Passing</th>
                          <th>Marking Scheme</th>
                          <th>Obtained Marks/CGPA</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>UG</td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Institute_Undergrad ||
                              studentProfileRecord?.applicanteducationaldetail
                                ?.University_Undergrad}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Month_And_Year_Of_Commencement_Undergrad ??
                              "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Month_And_Year_Of_Completion_Undergrad ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Marking_Scheme_Undergrad ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Grades_Undergrad ?? "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div> */}

                  {/* <div className="semesterWiseData">
                    <p className="heading">PostGraduate Academic Details</p>
                    <table
                      className="semesterWiseTable"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th>University/College</th>
                          <th>Month & Year Of Passing</th>
                          <th>Marking Scheme</th>
                          <th>Obtained Marks/CGPA</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>PG</td>
                          <td>
                            {
                              studentProfileRecord?.applicanteducationaldetail
                                ?.Institution_Name
                            }
                          </td>

                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Month_And_Year_Of_Completion_Undergrad ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Marking_Scheme_Undergrad ?? "N/A"}
                          </td>
                          <td>
                            {studentProfileRecord?.applicanteducationaldetail
                              ?.Grades_Undergrad ?? "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div> */}

                  {/* <div className="workDetailsContainer">
                    <div className="workDetailHeader">
                      <p className="heading">
                        Please tell us about your interests & hobbies
                      </p>
                    </div>
                    <div className="workDetailBody">
                      <p className="answer">
                        <span>
                          {studentProfileRecord?.applicantdetail?.Hobbies_Description.toLowerCase() ??
                            "N/A"}
                        </span>
                      </p>
                    </div>
                  </div> */}

                  {/* <div className="statementBox">
                    <p className="heading">
                      {" "}
                      PLEASE TELL US ABOUT YOUR INTERESTS & HOBBIES
                    </p>
                    <p className="statementQuestion"></p>
                    <p className="answer">
                      {studentProfileRecord?.applicantdetail
                        .Hobbies_Description ?? "N/A"}
                    </p>
                  </div> */}
                  <div className="filesContainer">
                    <div className="filesContainerHeader">
                      <p className="heading">Files</p>
                      <div className="linkdinLink"></div>
                    </div>
                    <div className="filesContainerBody">
                      {studentProfileRecord?.applicantadditionaldetail
                        ?.Upload_10th_Marksheet && (
                        <div className="fileContainer">
                          <p className="heading">Class 10th Marksheet</p>
                          <button className="downloadSuccessBtn">
                            <a
                              style={{ "text-decoration": "none" }}
                              target="_blank"
                              href={urlDocument(
                                studentProfileRecord?.applicationId,
                                studentProfileRecord?.applicantadditionaldetail
                                  ?.Upload_10th_Marksheet
                              )}
                            >
                              <p>View Document</p>
                            </a>
                            {/* <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M5.02148 7.22925C4.97505 7.18283 4.93822 7.12771 4.91309 7.06705C4.88795 7.00639 4.87502 6.94138 4.87501 6.87572C4.875 6.81006 4.88793 6.74504 4.91305 6.68438C4.93818 6.62371 4.975 6.56859 5.02142 6.52216C5.11518 6.42838 5.24235 6.3757 5.37496 6.37568C5.44062 6.37568 5.50563 6.38861 5.5663 6.41373C5.62696 6.43885 5.68208 6.47567 5.72852 6.5221L7.5 8.29311V2.5C7.5 2.36739 7.55268 2.24021 7.64645 2.14645C7.74021 2.05268 7.86739 2 8 2C8.13261 2 8.25979 2.05268 8.35355 2.14645C8.44732 2.24021 8.5 2.36739 8.5 2.5V8.29311L10.2715 6.5221C10.3179 6.47567 10.373 6.43885 10.4337 6.41372C10.4944 6.3886 10.5594 6.37568 10.625 6.37568C10.6907 6.37569 10.7557 6.38863 10.8164 6.41376C10.877 6.43889 10.9322 6.47572 10.9786 6.52216C11.025 6.56859 11.0618 6.62371 11.0869 6.68437C11.1121 6.74504 11.125 6.81006 11.125 6.87571C11.125 6.94137 11.112 7.00639 11.0869 7.06705C11.0618 7.12771 11.0249 7.18282 10.9785 7.22925L8.35352 9.85358C8.25975 9.94733 8.13259 10 8 10C7.86741 10 7.74025 9.94733 7.64648 9.85358L5.02148 7.22925ZM13.5 9C13.3674 9.00001 13.2402 9.05269 13.1465 9.14645C13.0527 9.24022 13 9.36739 13 9.5V13H3V9.5C3 9.36739 2.94732 9.24021 2.85355 9.14645C2.75979 9.05268 2.63261 9 2.5 9C2.36739 9 2.24021 9.05268 2.14645 9.14645C2.05268 9.24021 2 9.36739 2 9.5V13C2.0003 13.2651 2.10576 13.5193 2.29323 13.7068C2.4807 13.8942 2.73488 13.9997 3 14H13C13.2651 13.9997 13.5193 13.8942 13.7068 13.7068C13.8942 13.5193 13.9997 13.2651 14 13V9.5C14 9.36739 13.9473 9.24022 13.8535 9.14645C13.7598 9.05269 13.6326 9.00001 13.5 9V9Z"
                                      fill="#32B275"
                                    />
                                  </svg> */}
                          </button>
                        </div>
                      )}

                      {studentProfileRecord?.applicantadditionaldetail
                        ?.Upload_12th_Marksheet && (
                        <div className="fileContainer">
                          <p className="heading">Class 12th Marksheet :</p>
                          <button className="downloadSuccessBtn">
                            <a
                              target="_blank"
                              style={{ "text-decoration": "none" }}
                              href={urlDocument(
                                studentProfileRecord?.applicationId,
                                studentProfileRecord?.applicantadditionaldetail
                                  ?.Upload_12th_Marksheet
                              )}
                            >
                              <p>View Document</p>
                            </a>
                            {/* <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M5.02148 7.22925C4.97505 7.18283 4.93822 7.12771 4.91309 7.06705C4.88795 7.00639 4.87502 6.94138 4.87501 6.87572C4.875 6.81006 4.88793 6.74504 4.91305 6.68438C4.93818 6.62371 4.975 6.56859 5.02142 6.52216C5.11518 6.42838 5.24235 6.3757 5.37496 6.37568C5.44062 6.37568 5.50563 6.38861 5.5663 6.41373C5.62696 6.43885 5.68208 6.47567 5.72852 6.5221L7.5 8.29311V2.5C7.5 2.36739 7.55268 2.24021 7.64645 2.14645C7.74021 2.05268 7.86739 2 8 2C8.13261 2 8.25979 2.05268 8.35355 2.14645C8.44732 2.24021 8.5 2.36739 8.5 2.5V8.29311L10.2715 6.5221C10.3179 6.47567 10.373 6.43885 10.4337 6.41372C10.4944 6.3886 10.5594 6.37568 10.625 6.37568C10.6907 6.37569 10.7557 6.38863 10.8164 6.41376C10.877 6.43889 10.9322 6.47572 10.9786 6.52216C11.025 6.56859 11.0618 6.62371 11.0869 6.68437C11.1121 6.74504 11.125 6.81006 11.125 6.87571C11.125 6.94137 11.112 7.00639 11.0869 7.06705C11.0618 7.12771 11.0249 7.18282 10.9785 7.22925L8.35352 9.85358C8.25975 9.94733 8.13259 10 8 10C7.86741 10 7.74025 9.94733 7.64648 9.85358L5.02148 7.22925ZM13.5 9C13.3674 9.00001 13.2402 9.05269 13.1465 9.14645C13.0527 9.24022 13 9.36739 13 9.5V13H3V9.5C3 9.36739 2.94732 9.24021 2.85355 9.14645C2.75979 9.05268 2.63261 9 2.5 9C2.36739 9 2.24021 9.05268 2.14645 9.14645C2.05268 9.24021 2 9.36739 2 9.5V13C2.0003 13.2651 2.10576 13.5193 2.29323 13.7068C2.4807 13.8942 2.73488 13.9997 3 14H13C13.2651 13.9997 13.5193 13.8942 13.7068 13.7068C13.8942 13.5193 13.9997 13.2651 14 13V9.5C14 9.36739 13.9473 9.24022 13.8535 9.14645C13.7598 9.05269 13.6326 9.00001 13.5 9V9Z"
                                      fill="#32B275"
                                    />
                                  </svg> */}
                          </button>
                        </div>
                      )}

                      {studentProfileRecord?.applicantadditionaldetail
                        ?.Upload_Graduation_Certificate && (
                        <div className="fileContainer">
                          <p className="heading">Graduation certificate :</p>
                          <button className="downloadSuccessBtn">
                            <a
                              target="_blank"
                              style={{ "text-decoration": "none" }}
                              href={urlDocument(
                                studentProfileRecord?.applicationId,
                                studentProfileRecord?.applicantadditionaldetail
                                  ?.Upload_Graduation_Certificate
                              )}
                            >
                              <p>View Document</p>
                            </a>
                            {/* <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M5.02148 7.22925C4.97505 7.18283 4.93822 7.12771 4.91309 7.06705C4.88795 7.00639 4.87502 6.94138 4.87501 6.87572C4.875 6.81006 4.88793 6.74504 4.91305 6.68438C4.93818 6.62371 4.975 6.56859 5.02142 6.52216C5.11518 6.42838 5.24235 6.3757 5.37496 6.37568C5.44062 6.37568 5.50563 6.38861 5.5663 6.41373C5.62696 6.43885 5.68208 6.47567 5.72852 6.5221L7.5 8.29311V2.5C7.5 2.36739 7.55268 2.24021 7.64645 2.14645C7.74021 2.05268 7.86739 2 8 2C8.13261 2 8.25979 2.05268 8.35355 2.14645C8.44732 2.24021 8.5 2.36739 8.5 2.5V8.29311L10.2715 6.5221C10.3179 6.47567 10.373 6.43885 10.4337 6.41372C10.4944 6.3886 10.5594 6.37568 10.625 6.37568C10.6907 6.37569 10.7557 6.38863 10.8164 6.41376C10.877 6.43889 10.9322 6.47572 10.9786 6.52216C11.025 6.56859 11.0618 6.62371 11.0869 6.68437C11.1121 6.74504 11.125 6.81006 11.125 6.87571C11.125 6.94137 11.112 7.00639 11.0869 7.06705C11.0618 7.12771 11.0249 7.18282 10.9785 7.22925L8.35352 9.85358C8.25975 9.94733 8.13259 10 8 10C7.86741 10 7.74025 9.94733 7.64648 9.85358L5.02148 7.22925ZM13.5 9C13.3674 9.00001 13.2402 9.05269 13.1465 9.14645C13.0527 9.24022 13 9.36739 13 9.5V13H3V9.5C3 9.36739 2.94732 9.24021 2.85355 9.14645C2.75979 9.05268 2.63261 9 2.5 9C2.36739 9 2.24021 9.05268 2.14645 9.14645C2.05268 9.24021 2 9.36739 2 9.5V13C2.0003 13.2651 2.10576 13.5193 2.29323 13.7068C2.4807 13.8942 2.73488 13.9997 3 14H13C13.2651 13.9997 13.5193 13.8942 13.7068 13.7068C13.8942 13.5193 13.9997 13.2651 14 13V9.5C14 9.36739 13.9473 9.24022 13.8535 9.14645C13.7598 9.05269 13.6326 9.00001 13.5 9V9Z"
                                      fill="#32B275"
                                    />
                                  </svg> */}
                          </button>
                        </div>
                      )}

                      {studentProfileRecord?.applicantadditionaldetail
                        ?.Upload_Post_Graduation_Certificate && (
                        <div className="fileContainer">
                          <p className="heading">
                            Post Graduation Certificate :
                          </p>
                          <button className="downloadSuccessBtn">
                            <a
                              target="_blank"
                              style={{ "text-decoration": "none" }}
                              href={urlDocument(
                                studentProfileRecord?.applicationId,
                                studentProfileRecord?.applicantadditionaldetail
                                  ?.Upload_Post_Graduation_Certificate
                              )}
                            >
                              <p>View Document</p>
                            </a>
                            {/* <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M5.02148 7.22925C4.97505 7.18283 4.93822 7.12771 4.91309 7.06705C4.88795 7.00639 4.87502 6.94138 4.87501 6.87572C4.875 6.81006 4.88793 6.74504 4.91305 6.68438C4.93818 6.62371 4.975 6.56859 5.02142 6.52216C5.11518 6.42838 5.24235 6.3757 5.37496 6.37568C5.44062 6.37568 5.50563 6.38861 5.5663 6.41373C5.62696 6.43885 5.68208 6.47567 5.72852 6.5221L7.5 8.29311V2.5C7.5 2.36739 7.55268 2.24021 7.64645 2.14645C7.74021 2.05268 7.86739 2 8 2C8.13261 2 8.25979 2.05268 8.35355 2.14645C8.44732 2.24021 8.5 2.36739 8.5 2.5V8.29311L10.2715 6.5221C10.3179 6.47567 10.373 6.43885 10.4337 6.41372C10.4944 6.3886 10.5594 6.37568 10.625 6.37568C10.6907 6.37569 10.7557 6.38863 10.8164 6.41376C10.877 6.43889 10.9322 6.47572 10.9786 6.52216C11.025 6.56859 11.0618 6.62371 11.0869 6.68437C11.1121 6.74504 11.125 6.81006 11.125 6.87571C11.125 6.94137 11.112 7.00639 11.0869 7.06705C11.0618 7.12771 11.0249 7.18282 10.9785 7.22925L8.35352 9.85358C8.25975 9.94733 8.13259 10 8 10C7.86741 10 7.74025 9.94733 7.64648 9.85358L5.02148 7.22925ZM13.5 9C13.3674 9.00001 13.2402 9.05269 13.1465 9.14645C13.0527 9.24022 13 9.36739 13 9.5V13H3V9.5C3 9.36739 2.94732 9.24021 2.85355 9.14645C2.75979 9.05268 2.63261 9 2.5 9C2.36739 9 2.24021 9.05268 2.14645 9.14645C2.05268 9.24021 2 9.36739 2 9.5V13C2.0003 13.2651 2.10576 13.5193 2.29323 13.7068C2.4807 13.8942 2.73488 13.9997 3 14H13C13.2651 13.9997 13.5193 13.8942 13.7068 13.7068C13.8942 13.5193 13.9997 13.2651 14 13V9.5C14 9.36739 13.9473 9.24022 13.8535 9.14645C13.7598 9.05269 13.6326 9.00001 13.5 9V9Z"
                                      fill="#32B275"
                                    />
                                  </svg> */}
                          </button>
                        </div>
                      )}

                      {studentProfileRecord?.applicantadditionaldetail
                        ?.Upload_CV && (
                        <div className="fileContainer">
                          <p className="heading">CV :</p>
                          <button className="downloadSuccessBtn">
                            <a
                              style={{ "text-decoration": "none" }}
                              target="_blank"
                              href={urlDocument(
                                studentProfileRecord?.applicationId,
                                studentProfileRecord?.applicantadditionaldetail
                                  ?.Upload_CV
                              )}
                            >
                              <p>View Document</p>
                            </a>
                            {/* <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M5.02148 7.22925C4.97505 7.18283 4.93822 7.12771 4.91309 7.06705C4.88795 7.00639 4.87502 6.94138 4.87501 6.87572C4.875 6.81006 4.88793 6.74504 4.91305 6.68438C4.93818 6.62371 4.975 6.56859 5.02142 6.52216C5.11518 6.42838 5.24235 6.3757 5.37496 6.37568C5.44062 6.37568 5.50563 6.38861 5.5663 6.41373C5.62696 6.43885 5.68208 6.47567 5.72852 6.5221L7.5 8.29311V2.5C7.5 2.36739 7.55268 2.24021 7.64645 2.14645C7.74021 2.05268 7.86739 2 8 2C8.13261 2 8.25979 2.05268 8.35355 2.14645C8.44732 2.24021 8.5 2.36739 8.5 2.5V8.29311L10.2715 6.5221C10.3179 6.47567 10.373 6.43885 10.4337 6.41372C10.4944 6.3886 10.5594 6.37568 10.625 6.37568C10.6907 6.37569 10.7557 6.38863 10.8164 6.41376C10.877 6.43889 10.9322 6.47572 10.9786 6.52216C11.025 6.56859 11.0618 6.62371 11.0869 6.68437C11.1121 6.74504 11.125 6.81006 11.125 6.87571C11.125 6.94137 11.112 7.00639 11.0869 7.06705C11.0618 7.12771 11.0249 7.18282 10.9785 7.22925L8.35352 9.85358C8.25975 9.94733 8.13259 10 8 10C7.86741 10 7.74025 9.94733 7.64648 9.85358L5.02148 7.22925ZM13.5 9C13.3674 9.00001 13.2402 9.05269 13.1465 9.14645C13.0527 9.24022 13 9.36739 13 9.5V13H3V9.5C3 9.36739 2.94732 9.24021 2.85355 9.14645C2.75979 9.05268 2.63261 9 2.5 9C2.36739 9 2.24021 9.05268 2.14645 9.14645C2.05268 9.24021 2 9.36739 2 9.5V13C2.0003 13.2651 2.10576 13.5193 2.29323 13.7068C2.4807 13.8942 2.73488 13.9997 3 14H13C13.2651 13.9997 13.5193 13.8942 13.7068 13.7068C13.8942 13.5193 13.9997 13.2651 14 13V9.5C14 9.36739 13.9473 9.24022 13.8535 9.14645C13.7598 9.05269 13.6326 9.00001 13.5 9V9Z"
                                      fill="#32B275"
                                    />
                                  </svg> */}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`profileTab  ${
                  renderComponent === 1 ? "active" : ""
                }`}
              >
                <div className="profileTabHeader">
                  <p className="heading">Timeline</p>
                </div>
                <div className="profileTabBody">
                  {timeLineArray.map((item, index) => {
                    const { id, message, comment, createdAt } = item;
                    return (
                      <div key={id} className="timelineDetailList">
                        <div className="timelineDate">
                          {moment(createdAt).format("DD MMM YYYY hh:mm A")}
                        </div>
                        <div className="timelineIcon">
                          <img
                            src="../assets/icons/timelineIcon12.png"
                            alt=""
                          />
                        </div>
                        <div className="timelineText">{message}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                className={`profileTab  ${
                  renderComponent === 2 ? "active" : ""
                }`}
              >
                <div className="profileTabHeader withButton">
                  <p className="heading">Follow Up & Notes</p>
                  <div className="groupBtn">
                    <Button
                      onClick={() => {
                        setAddNotePopup(true);
                        setNoteType("normalNote");
                      }}
                      className={"whiteBtn"}
                      name={"Add Note"}
                      src={"/assets/icons/plus.svg"}
                    />
                    <Button
                      onClick={() => {
                        setAddNotePopup(true);
                        setNoteType("followUpNote");
                      }}
                      className={"blackBtn"}
                      name={"Add Follow Up"}
                      src={"/assets/icons/plus.svg"}
                    />
                  </div>
                </div>
                <div className="profileTabBody">
                  {followUpArray.map((item) => {
                    const { id, createdAt, note, Admin } = item;
                    return (
                      <div key={id} className="timelineDetailList">
                        <div className="timelineDate">
                          {moment(createdAt).format("DD MMM YYYY hh:mm A")}
                        </div>
                        <div className="timelineIcon">
                          <img
                            src="../assets/icons/timelineIcon11.png"
                            alt=""
                          />
                        </div>
                        <div className="timelineText">
                          <strong>Note: </strong> {note}
                          <small>
                            Added by: {Admin?.firstName} {Admin?.lastName}
                          </small>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                className={`profileTab  ${
                  renderComponent === 3 ? "active" : ""
                }`}
              >
                <div className="profileTabHeader withButton">
                  <p className="heading">Fee Dues</p>
                  <div className="groupBtn">
                    <Button
                      onClick={() => {
                        toggleFeeDuePopup();
                        setFeeAmount("");
                        setDueType("createFeeDue");
                        setDueDate("");
                      }}
                      className={"whiteBtn"}
                      name={"Fee Due"}
                      src={"/assets/icons/plus.svg"}
                    />
                  </div>
                </div>

                <div className="singleStudentTableOuter">
                  <table
                    className="fee-details-table w-100 singleStudentTableHead"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <thead>
                      <tr>
                        <th>Fee Type</th>
                        <th>Fee Due Date</th>
                        <th>Due Amount</th>
                        <th>Paid Amount</th>
                        <th>Subvention Amount</th>
                        <th>Submitted Date</th>
                        <th>Transaction Type</th>
                        <th>Payment Mode</th>
                        <th>Payment Status</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {studentFeeDueData &&
                        studentFeeDueData.FeeDues.map((due, index) => (
                          <tr key={due?.id}>
                            <td>{due.Fee.FeeMaster.feeName}</td>
                            <td>
                              <p className="text-primary">
                                {moment(due?.dueOn).format("DD-MM-YYYY")}
                              </p>
                            </td>
                            <td>
                              <p>₹ {due.feeDue}</p>
                            </td>
                            <td>
                              {due?.isPaid ? (
                                <p className="text-success">
                                  ₹ {due?.FeeTransactions[0]?.amount}
                                </p>
                              ) : (
                                "--"
                              )}
                            </td>

                            <td>
                              {due?.FeeTransactions[0]?.subventionAmount === 0
                                ? "--"
                                : due?.FeeTransactions[0]?.subventionAmount}
                            </td>
                            <td>
                              {due?.isPaid ? (
                                <>
                                  {moment(
                                    due?.FeeTransactions[0].paidOn
                                  ).format("DD-MM-YYYY")}
                                </>
                              ) : (
                                "--"
                              )}
                            </td>
                            <td>
                              <div className="dFlex">
                                {due.isPaid ? (
                                  <>
                                    {due.isBankTransfer && (
                                      <p className="tag-active">
                                        NEFT / IMPS / RTGS
                                      </p>
                                    )}
                                    {due.isMuLoan && (
                                      <p className="tag-active">MU Loan</p>
                                    )}
                                    {due.isBankLoan && (
                                      <p className="tag-active">Bank Loan</p>
                                    )}
                                    {due.cashFreeStatus === "paid" && (
                                      <p className="tag-active">
                                        Cash Free / UPI
                                      </p>
                                    )}
                                    {due.isFlex && (
                                      <p className="tag-active">Jodo Flex</p>
                                    )}

                                    <img
                                      onClick={() => {
                                        toggleUpdateFeePopup();

                                        setLoanDetails(due);
                                        setUpdateType("editFee");
                                        setFeeDueId(due?.id);
                                      }}
                                      src="../assets/icons/edit.svg"
                                      alt=""
                                      className="pointer"
                                    />
                                  </>
                                ) : (
                                  "--"
                                )}
                              </div>
                            </td>

                            <td>
                              <div className="dFlex">
                                <>
                                  {due.isFullLoan && (
                                    <p className="tag-active">Full Loan</p>
                                  )}

                                  {due.isOneTimePayment && (
                                    <p className="tag-active">
                                      One Time Payment
                                    </p>
                                  )}

                                  {due.isPartialLoan && (
                                    <p className="tag-active">Partial Loan</p>
                                  )}

                                  {due.isPartialOtp && (
                                    <p className="tag-active">Partial Otp</p>
                                  )}

                                  {due.isAdmissionsFee && (
                                    <p className="tag-active">Admission Fee</p>
                                  )}

                                  {due.isFlexToBeRecieved && (
                                    <p className="tag-active">
                                      Flex to be received
                                    </p>
                                  )}

                                  {due.isFlexRecieved && (
                                    <p className="tag-active">Flex Received</p>
                                  )}
                                </>
                                <img
                                  onClick={() => {
                                    toggleStudentStatusPopup();
                                    setStatusType("paymentMethod");
                                    setFeeDueId(due?.id);
                                  }}
                                  src="../assets/icons/edit.svg"
                                  alt=""
                                  className="pointer"
                                />
                              </div>
                            </td>

                            <td>
                              {due.isPaid ? (
                                <p className="success-light-btn-a no_click">
                                  Paid
                                </p>
                              ) : !viewOnlyAccess ? (
                                <p
                                  className="success-light-btn-a succcess_color_blue"
                                  onClick={() => {
                                    toggleUpdateFeePopup();

                                    setUpdateType("updateFee");
                                    setFeeDueId(due?.id);
                                  }}
                                >
                                  Pay
                                </p>
                              ) : (
                                <p>--</p>
                              )}
                            </td>

                            <td className="text-center">
                              <button
                                className="action-btn"
                                onClick={() => openActionMenu(index)}
                                onBlur={closeActionMenu}
                              >
                                <img src="../assets/icons/options.svg" />
                                <ul
                                  className={
                                    menuId === index
                                      ? "action-dropdown active approval-drpdown"
                                      : "action-dropdown approval-drpdown"
                                  }
                                >
                                  {!due.isPaid && (
                                    <li
                                      className="dropdown-item"
                                      onClick={() => {
                                        toggleFeeDuePopup();
                                        setFeeAmount(due.feeDue);
                                        setDueType("editFeeDue");
                                        setFeeDueId(due?.id);
                                        setDueDate(due?.dueOn);
                                        setFeeId(due?.Fee?.FeeMaster?.id);
                                      }}
                                    >
                                      <img
                                        src="../assets/icons/edit.svg"
                                        alt=""
                                      />
                                      <p className="dropdown-text">Edit Due</p>
                                    </li>
                                  )}
                                  <li
                                    onClick={() =>
                                      navigator.clipboard.writeText(
                                        due?.paymentLink
                                      )
                                    }
                                    className="dropdown-item "
                                  >
                                    <img
                                      src="../assets/icons/copy.svg"
                                      alt=""
                                    />
                                    <p className="dropdown-text">
                                      Copy Payment Link
                                    </p>
                                  </li>

                                  <li
                                    className="dropdown-item"
                                    onClick={() => onClickDeleteButton(due?.id)}
                                  >
                                    <img
                                      src="../assets/icons/delete.svg"
                                      alt=""
                                    />
                                    <p className="dropdown-text">Delete</p>
                                  </li>

                                  {due?.isPaid && due?.isBankLoan && (
                                    <li
                                      onClick={() => {
                                        toggleUpdateFeePopup();
                                        setUpdateType("loanDetail");
                                        setFeeDueId(due?.id);
                                        setLoanDetails(due);
                                      }}
                                      className="dropdown-item "
                                    >
                                      <img
                                        src="../assets/icons/copy.svg"
                                        alt=""
                                      />
                                      <p className="dropdown-text">
                                        Loan Details
                                      </p>
                                    </li>
                                  )}
                                </ul>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className={`profileTab  ${
                  renderComponent === 4 ? "active" : ""
                }`}
              >
                <div className="profileTabHeader withButton">
                  <p className="heading">Transactions</p>
                  <div className="groupBtn">
                    <Button
                      onClick={() => {
                        toggleStudentStatusPopup();
                        setStatusType("updateAddress");

                        setStudentDetails({
                          address: studentFeeDueData?.address,
                          supplyPlace: studentFeeDueData?.supplyPlace,
                          studentGSTNo: studentFeeDueData?.studentGSTNo,
                        });
                      }}
                      className={"whiteBtn"}
                      name={"Update Address"}
                      src={"/assets/icons/plus.svg"}
                    />
                  </div>
                </div>
                <table
                  // className="fee-details-table w-100 singleStudentTableHead"
                  className="fee-details-table w-100"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <thead>
                    <tr>
                      <th>Fee Type</th>
                      <th>Fee Due Date</th>
                      <th>Submited Amount</th>
                      <th>Submited Date</th>
                      <th>Fee method</th>
                      <th>Receipt No.</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {singleStudentData &&
                      singleStudentData.FeeDues.map((due, index) =>
                        due.FeeTransactions.map((ft) => (
                          <tr key={ft?.id}>
                            <td>{due.Fee.FeeMaster.feeName}</td>
                            <td>
                              <p className="text-primary">
                                {moment(due?.dueOn).format("DD-MM-YYYY")}
                              </p>
                            </td>
                            <td>
                              <p className="text-success">₹ {ft.amount}</p>
                            </td>
                            <td>{moment(ft?.paidOn).format("DD-MM-YYYY")}</td>
                            <td>
                              {due.isBankTransfer && (
                                <p className="tag-active">Bank Transfer</p>
                              )}
                              {due.isMuLoan && (
                                <p className="tag-active">MU Loan</p>
                              )}
                              {due.isBankLoan && (
                                <p className="tag-active">Bank Loan</p>
                              )}
                              {due.cashFreeStatus === "paid" && (
                                <p className="tag-active">Cash Free</p>
                              )}

                              {due.isFlex && (
                                <p className="tag-active">Jodo Flex</p>
                              )}
                            </td>

                            <td>
                              {ft.receiptNumber}{" "}
                              <img
                                onClick={() => {
                                  toggleStudentStatusPopup();
                                  setStatusType("updateReceiptNo");
                                  setFeeDueId(ft?.id);
                                }}
                                src="../assets/icons/edit.svg"
                                alt=""
                                className="pointer"
                              />
                            </td>

                            <td className="text-center">
                              <button
                                className="action-btn"
                                onClick={() => openActionMenu(index)}
                                onBlur={closeActionMenu}
                              >
                                <img src="../assets/icons/options.svg" />
                                <ul
                                  className={
                                    menuId === index
                                      ? "action-dropdown active approval-drpdown"
                                      : "action-dropdown approval-drpdown"
                                  }
                                >
                                  <li
                                    onClick={() => onDownloadReceipt(due, ft)}
                                    className="dropdown-item "
                                  >
                                    <img src="../assets/icons/Eye.svg" alt="" />
                                    <p className="dropdown-text">Fee Receipt</p>
                                  </li>

                                  <li
                                    className="dropdown-item"
                                    onClick={() =>
                                      openInNewTab(due?.paymentRecieptLink)
                                    }
                                  >
                                    <img src="../assets/icons/Eye.svg" alt="" />
                                    <p className="dropdown-text">Pdf receipt</p>
                                  </li>

                                  <li
                                    className="dropdown-item"
                                    onClick={() =>
                                      onDownloadTaxInvoice(due, ft)
                                    }
                                  >
                                    <img src="../assets/icons/Eye.svg" alt="" />
                                    <p className="dropdown-text">Tax Invoice</p>
                                  </li>
                                </ul>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleStudentFee;
